module.exports = __webpack_public_path__ + "img/insurances.6f1ba4eb.svg";